import styles from './styles.module.scss';

export interface ContactData {
  id: string;
  name: string;
  contactType: 'person' | 'company';
}

interface MobileContactItemProps {
  contact: ContactData;
  onClick: () => void;
}

export const MobileContactItem: React.FC<MobileContactItemProps> = ({ contact, onClick }) => {
  return (
    <div className={styles.contactItem} onClick={onClick}>
      <div className={styles.contactItem__name}>{contact.name}</div>
      <span className={`${styles.typePill} ${styles[`typePill--${contact.contactType}`]}`}>
        {contact.contactType === 'person' ? 'Person' : 'Company'}
      </span>
    </div>
  );
};
